
















import { Vue, Component, Prop } from "vue-property-decorator";
import design from "../../assets/scss/_variables.scss";

/**
 * The *anx-button* is based on a standard HTML button.
 * It can be used like a normal button, but has some convenient features.
 */
@Component({})
export default class AnxButton extends Vue {
  /** This is the type of the button (will be set as html *type* property) */
  @Prop({ default: "submit" }) btnType!: string;
  /** Changes the button layout to outline */
  @Prop({ default: null }) outline!: boolean | null;
  /** This is the text of the button. This can also be set using the slot */
  @Prop({ default: "button" }) text!: string;
  /** This is the width of the button */
  @Prop({ default: null }) width!: string | null;
  /** With this property, the button can be set to inline */
  @Prop({ default: null }) inline!: boolean | null;
  /** This is the name of the event, that will be emitted on click */
  @Prop({ default: "click" }) eventName!: string;
  /** Set the color of the button (property will be directly passed into css, so use e.g. HEX code) */
  @Prop({ default: null }) color!: string | null;
  /** This is the color for a disabled button */
  @Prop({ default: null }) disabledColor!: string | null;

  /** @ignore */
  get cssProps() {
    return {
      "--button-width": this.width !== null ? this.width : "auto",
      "--button-color":
        this.color !== null ? this.color : design.defaultButtonColor,
      "--button-color-disabled":
        this.disabledColor !== null
          ? this.disabledColor
          : design.defaultButtonColorDisabled
    };
  }
}
